<template>
    <section class="init_box" style="background-color:white;z-index: 10;">
        <el-row>
            <el-col :span="24" style="margin-top: 10px;">
                <span v-if="btnShow.indexOf('detail') != -1">
                    <el-button class="btn" type="primary" size="small" v-if="btnRole.indexOf('13') != -1"
                        @click="toWeiBao">维保申请</el-button>
                    <el-button class="btn" type="primary" size="small" v-if="btnRole.indexOf('19') != -1"
                        @click="toBaoFei">报废申请</el-button>
                    <el-button class="btn" type="primary" size="small" v-if="btnRole.indexOf('11') != -1"
                        @click="toCheck">检定申请</el-button>
                    <!-- <el-button class="btn" type="primary">使用记录</el-button> -->
                    <el-button class="btn" size="small" v-if="btnRole.indexOf('131') != -1" type="primary"
                        @click="toUpdate">设备编辑</el-button>

                    <el-button class="btn" size="small" type="primary" @click="toWarning">设备检定</el-button>
                    <el-button class="btn" size="small" type="primary" @click="toCalibrationWarning">校准录入</el-button>
                </span>
                <el-button class="btn" size="small"
                    v-if="btnResult.indexOf('fail') != -1 && btnRole.indexOf('194') != -1 && btnShow.indexOf('examine') != -1"
                    type="primary" @click="toUpdate">设备编辑</el-button>
                <el-button class="btn" size="small"
                    v-if="btnResult.indexOf('loading') != -1 && btnRole.indexOf('137') != -1 && btnShow.indexOf('examine') != -1"
                    type="primary" @click="clickTongg">通过</el-button>
                <el-button class="btn" size="small"
                    v-if="btnResult.indexOf('loading') != -1 && btnRole.indexOf('137') != -1 && btnShow.indexOf('examine') != -1"
                    type="danger" @click="rejectDialog = true">驳回</el-button>
                <el-button class="btn" size="small" type="info" style="margin-left:10px"
                    @click="returnDeviceinfo">返回</el-button>
            </el-col>
        </el-row>
        <!-- 审核时的编辑内容对照：展示本次修改的字段（旧值 → 新值），数据来自 deviceinfo_drafts 快照 -->
        <el-row v-if="btnShow.indexOf('examine') != -1 && editDiff && editDiff.hasDraft"
            style="margin-top:15px;margin-left:10px">
            <el-col :span="20" style="margin-left:10px">
                <div
                    style="background:linear-gradient(135deg,#fdf6ec,#faecd8);border:1px solid #f3d19e;border-left:4px solid #e6a23c;border-radius:6px;padding:14px 18px;">
                    <div style="display:flex;align-items:center;margin-bottom:8px;">
                        <span
                            style="background:linear-gradient(135deg,#e6a23c,#cf8f2f);color:#fff;font-size:12px;font-weight:bold;border-radius:12px;padding:3px 12px;margin-right:10px;box-shadow:0 1px 3px rgba(230,162,60,.4);white-space:nowrap;">
                            ✎ 本次修改
                        </span>
                        <span style="color:#303133;font-size:15px;font-weight:bold;">
                            共 {{ changedEditFields.length }} 处字段变更
                        </span>
                    </div>
                    <div style="color:#5a3d1b;font-size:13px;margin-bottom:10px;">
                        修改人：<b style="color:#303133;">{{ editDiff.editor || '-' }}</b>
                        <span style="margin:0 8px;color:#d3b98a;">|</span>
                        修改时间：<b style="color:#303133;">{{ editDiff.editTime || '-' }}</b>
                    </div>
                    <div v-for="(f, i) in changedEditFields" :key="i"
                        style="line-height:30px;font-size:14px;border-bottom:1px dashed #f3d19e;padding:0 4px;">
                        <span style="color:#303133;font-weight:bold;">{{ f.label }}：</span>
                        <span style="color:#909399;text-decoration:line-through;">{{ f.old || '（空）' }}</span>
                        <span style="margin:0 6px;color:#e6a23c;font-weight:bold;">→</span>
                        <span style="color:#F56C6C;font-weight:bold;">{{ f.new || '（空）' }}</span>
                    </div>
                    <div v-if="changedEditFields.length == 0" style="color:#909399;font-size:13px;margin-top:6px;">
                        敏感字段无变化（可能为驳回后重新提交）
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row v-else-if="btnShow.indexOf('examine') != -1 && editDiff && !editDiff.hasDraft && btnResult.indexOf('loading') != -1"
            style="margin-top:15px;margin-left:10px">
            <el-col :span="20" style="margin-left:10px">
                <div
                    style="background:linear-gradient(135deg,#ecf5ff,#d9ecff);border:1px solid #b3d8ff;border-radius:6px;padding:12px 16px;display:flex;align-items:center;">
                    <span
                        style="background:linear-gradient(135deg,#409EFF,#2b85e4);color:#fff;font-size:12px;font-weight:bold;border-radius:12px;padding:3px 12px;margin-right:10px;box-shadow:0 1px 3px rgba(64,158,255,.4);white-space:nowrap;">
                        ✦ 新录入
                    </span>
                    <span style="color:#2b85e4;font-size:14px;font-weight:bold;">
                        该设备为新录入，无编辑修改对照，请直接核对完整信息后审核
                    </span>
                </div>
            </el-col>
        </el-row>
        <el-row style="margin-top:15px;margin-left:10px">
            <el-form :model="deviceData" style="margin-left:10px " label-width="auto">
                <el-col :span="10">
                    <el-form-item v-for="(item, index) in formLeft" :key="item.key" :label="item.key">
                        <el-input size="small" readonly class="input" v-model="item.value">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item v-for="(item, index) in formRight" :key="item.key" :label="item.key">
                        <!-- <el-input v-if="item.key !== '备注'" size="small" readonly class="input" v-model="item.value">
                        </el-input> -->
                        <el-input size="small" readonly class="input" v-model="item.value">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="20">
                    <el-collapse v-model="activeName">
                        <el-collapse-item name="other" v-if="isShows">
                            <template slot="title" class="collapse-title">
                                <span style="margin-left:10px">资产信息</span>
                            </template>
                            <el-row style="margin-top:15px;margin-left:10px">
                                <el-col :span="12">
                                    <el-form-item v-for="(item, index) in formDetailLeft" :key="item.key"
                                        :label="item.key">
                                        <el-input size="small" readonly v-model="item.value"
                                            style="width:92%;margin-left: -25px;">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item v-for="(item, index) in formDetailRight" :key="item.key"
                                        :label="item.key">
                                        <el-input size="small" readonly v-model="item.value" style="width:92%;">
                                        </el-input>
                                    </el-form-item>

                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="relevant">
                            <template slot="title">
                                <span style="margin-left:10px">设备资料</span>
                            </template>
                            <el-row>
                                <el-col :span="23">
                                    <el-table style="margin-left:30px" :data="deviceDocData" :row-key="getRowKeys">
                                        <el-table-column type="index" label="序号" width="70"></el-table-column>
                                        <el-table-column prop="name" label="资料名称" width="200"></el-table-column>
                                        <el-table-column prop="type" label="资料类型" width="200"></el-table-column>
                                        <el-table-column prop="createUser" label="上传人" width="170"></el-table-column>
                                        <el-table-column prop="createTime" label="上传日期" width="150"
                                            :formatter="formateTime"></el-table-column>
                                        <el-table-column prop="remark" label="备注" width="200"></el-table-column>
                                        <el-table-column label="操作">
                                            <template slot-scope="scope">
                                                <!-- <el-link :underline="false" style="color: #4095E5;text-decoration: none;"
                                                    @click="updateDocBtn(scope.row)">编辑 </el-link>
                                                <el-link :underline="false" style="color: #4095E5;text-decoration: none;"
                                                    @click="deleteDeviceDoc(scope.row)">删除 </el-link> -->
                                                <el-link :underline="false"
                                                    style="color: #4095E5;text-decoration: none;"
                                                    @click="onlineView(scope.row)">预览 </el-link>
                                                <el-link :underline="false"
                                                    style="color: #4095E5;text-decoration: none;"
                                                    @click="downloading(scope.row)">下载 </el-link>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="annex">
                            <template slot="title">
                                <span style="margin-left:10px">设备附件({{ annexNum }})</span>
                            </template>
                            <el-row>
                                <el-col :span="23">
                                    <el-table :data="annexData" stripe style="margin-left: 10px;" :row-key="getRowKeys">
                                        <el-table-column type="index" label="序号" width="80">
                                        </el-table-column>
                                        <el-table-column prop="zcmc" label="名称" show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column prop="ccbh" label="出厂编号" show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column prop="cgrq" label="采购日期" show-overflow-tooltip>
                                        </el-table-column>
                                        <!-- <el-table-column prop="sl" label="数量"  show-overflow-tooltip>
                                            </el-table-column>
                                            <el-table-column prop="dw" label="单位"  show-overflow-tooltip>
                                            </el-table-column> -->
                                        <el-table-column prop="jdlx" label="检定类型" show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.jdlx == 0">检定</span>
                                                <span v-if="scope.row.jdlx == 1">核查</span>
                                                <span v-if="scope.row.jdlx == 2">校准</span>
                                                <span v-if="scope.row.jdlx == 3">不检定/校准</span>
                                            </template>
                                        </el-table-column>
                                        <!-- <el-table-column prop="jdzq" label="检定周期"  show-overflow-tooltip>
                                            </el-table-column> -->
                                        <el-table-column prop="clfw" label="测量范围" show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column prop="cljd" label="测量精度" show-overflow-tooltip>
                                        </el-table-column>
                                        <!-- <el-table-column prop="lrrq" label="上传日期"
                                                show-overflow-tooltip :formatter="formateTime">
                                            </el-table-column> -->
                                        <el-table-column prop="bz" label="备注" show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column label="操作">
                                            <template slot-scope="scope">
                                                <el-link :underline="false"
                                                    style="color: #4095E5;text-decoration: none;"
                                                    v-if="btnRole.indexOf('142') != -1"
                                                    @click="clickAnnexDetail(scope.row)">详情 </el-link>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="detail">
                            <template slot="title">
                                <span style="margin-left:10px">详细信息</span>
                            </template>
                            <el-row>
                                <el-col :span="23" style="margin-left:20px">
                                    <el-tabs v-model="activeNameDetail" @tab-click="handleClick">
                                        <el-tab-pane label="使用记录" name="useRecord">
                                            <DeviceUseRecord :deviceinfo="this.deviceData" style="margin-top:-13px">
                                            </DeviceUseRecord>
                                        </el-tab-pane>
                                        <el-tab-pane label="设备轨迹" name="deviceLocus">
                                            <DeviceLocus :deviceinfo="this.deviceData" style="margin-top:-13px">
                                            </DeviceLocus>
                                        </el-tab-pane>
                                        <el-tab-pane label="检定/校准记录" name="checkRecord">
                                            <DeviceCheckRecord :deviceinfo="this.deviceData" style="margin-top:-13px">
                                            </DeviceCheckRecord>
                                        </el-tab-pane>
                                        <el-tab-pane label="维保记录" name="wbRecord">
                                            <WbRecord :deviceinfo="this.deviceData" style="margin-top:-13px"></WbRecord>
                                        </el-tab-pane>
                                        <el-tab-pane label="借用记录" name="borrowingRecord">
                                            <BorrowingRecord :deviceinfo="this.deviceData" style="margin-top:-13px">
                                            </BorrowingRecord>
                                        </el-tab-pane>
                                    </el-tabs>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-form>
        </el-row>
        <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
            <FilePreview ref="filePreview" />
        </el-dialog>
        <!-- 点击驳回弹窗 -->
        <el-dialog title="驳回意见" :close-on-click-modal="false" :close-on-press-escape="false"
            :visible.sync="rejectDialog" width="25%" @close="clickExit">
            <el-form :model="deviceExamine" ref="deviceExamine" label-position="left" label-width="100px"
                style="width: 90%; margin-left: 5%">

                <el-form-item label="审核意见" prop="shyj" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-input placeholder="请输入审核意见" style="width: 100%" v-model="deviceExamine.shyj" />
                </el-form-item>

            </el-form>
            <div style="margin-top: 15px;">
                <el-button style="width: 25%;" type="primary" @click="clickReject">驳回</el-button>
                <el-button style="width: 25%;" type="primary" @click="clickExit">取消</el-button>
            </div>


        </el-dialog>
        <!-- 附件详情 -->
        <el-dialog title="附件详情" :close-on-click-modal="false" :close-on-press-escape="false"
            :visible.sync="annexDetailDialog" width="50%">
            <annex-detail ref="annexDetailShow" :annexId="deviceAnnexId"></annex-detail>
        </el-dialog>
    </section>
</template>
<script>
import DeviceUseRecord from './components/DeviceUseRecord.vue';
import DeviceLocus from './components/DeviceLocus.vue';
import DeviceCheckRecord from './components/DeviceCheckRecord.vue';
import WbRecord from './components/wbRecord';
import BorrowingRecord from './components/BorrowingRecord';
import FilePreview from '../../components/preview/FilePreview.vue';
import AnnexDetail from './components/AnnexDetail.vue';
import { selectDeviceinfoDoc, selectAnnex, selectDeviceinfoByid, examine, selectDeviceFenlei, selectEditDiff } from '../../api/api';
export default {
    components: { DeviceUseRecord, DeviceLocus, DeviceCheckRecord, WbRecord, FilePreview, AnnexDetail, BorrowingRecord },
    data() {
        return {
            activeName: 'other',
            activeNameDetail: 'useRecord',
            btnShow: sessionStorage.getItem("from"),
            btnResult: sessionStorage.getItem("examineResult"),
            deviceData: {},
            annexNum: 0,
            deviceTable: [],
            formLeft: [],
            formRight: [],
            formDetailLeft: [],
            formDetailRight: [],
            relevantData: [],//存放资料数据
            annexData: [],//存放附件数据
            deviceDocData: [],
            docxdialog: false,
            rejectDialog: false,
            previewTitle: "",
            btnRole: [],
            isShows: false,
            annexData: [],
            deviceExamine: {
                shyj: ""
            },
            deviceAnnexId: "",
            annexDetailDialog: false,
            editDiff: null//审核时的编辑差异（旧值快照 vs 当前值）
        }
    },
    computed: {
        //有变化（旧值≠新值）的编辑字段
        changedEditFields() {
            if (!this.editDiff || !this.editDiff.fields) return [];
            return this.editDiff.fields.filter(f => f.changed);
        }
    },
    methods: {
        getRowKeys(row) {
            return row.id;
        },
        getFormList() {
            let deviceinfoLable = JSON.parse(sessionStorage.getItem("deviceinfoLable")) || [];
            for (var i = 0; i < deviceinfoLable.length; i++) {
                if (deviceinfoLable[i].showPostion == 2 || deviceinfoLable[i].showPostion == 4 || deviceinfoLable[i].showPostion == 5 || deviceinfoLable[i].showPostion == 6) {
                    if (deviceinfoLable[i].isShow != 0) {
                        this.deviceTable.push(deviceinfoLable[i])
                    }
                }
            }
            // 定义变量保存原始详情数据
            // this.deviceData = JSON.parse(sessionStorage.getItem("deviceinfoDetail"))
            // 定义变量保存设备类型数据
            let deviceTypeData = JSON.parse(sessionStorage.getItem("deviceTypeData"))
            // 定义变量保存专业分类数据
            let zyflData = JSON.parse(sessionStorage.getItem("zyflData"))
            // 定义变量保存项目分类数据
            let xmflData = JSON.parse(sessionStorage.getItem("xmflData"))
            // 定义变量保存设备状态数据
            let deviceStatuData = JSON.parse(sessionStorage.getItem("deviceStatuData")) || [];
            // 判断将一级分类转化为名称
            let deviceDetail = JSON.parse(sessionStorage.getItem("deviceinfoDetail"));
            if (!deviceDetail) {
                this.$message.error('设备详情数据丢失，请从设备列表重新进入');
                return;
            }
            let deviceId = deviceDetail.id;
            // 审核入口进入时，加载本次编辑的修改对照（旧值→新值）
            if (this.btnShow && this.btnShow.indexOf('examine') != -1) {
                selectEditDiff(deviceId).then(datas => {
                    if (datas.status == 200) {
                        this.editDiff = datas.data;
                    }
                });
            }
            let _this = this
            let _params = {
                level: 0,
            }
            selectDeviceFenlei(_params).then(resultDatas => {
                // this.deviceData['yjfl']="123456"
                console.log("resultDatas", resultDatas)
                let resultData = resultDatas.data
                selectDeviceinfoByid(deviceId).then(datas => {
                    let { data, status, message } = datas
                    if (status == 200) {
                        this.deviceData = data;
                        // _this.formateYjfl(data)
                        let yjflName = ""
                        let zyid = ""
                        for (var i = 0; i < resultData.length; i++) {
                            if (data.yjfl == resultData[i].id) {
                                this.deviceData['yjfl'] = resultData[i].deviceTypeName
                            }
                            if (data.ejfl == resultData[i].id) {
                                this.deviceData['ejfl'] = resultData[i].deviceTypeName
                            }
                            if (data.yjfl != "P0001") {
                                if (resultData[i].level == 2 && resultData[i].code == data.zyfl) {
                                    zyid = resultData[i].id
                                    this.deviceData['zyfl'] = resultData[i].deviceTypeName
                                }
                                if (resultData[i].pid == zyid && resultData[i].level == 3 && resultData[i].code == data.xmfl) {
                                    this.deviceData['xmfl'] = resultData[i].deviceTypeName
                                }
                            }


                        }

                        // // 判断将专业分类转化为名称
                        // let zyid = _this.deviceData.zyfl
                        // for (var i = 0; i < zyflData.length; i++) {
                        //     if (_this.deviceData.zyfl == zyflData[i].id) {
                        //         _this.deviceData['zyfl'] = zyflData[i].name
                        //     }
                        // }
                        // 判断将项目分类转化为名称
                        // for (var i = 0; i < xmflData.length; i++) {
                        //     if (_this.deviceData.xmfl == xmflData[i].id && xmflData[i].mId == zyid) {
                        //         _this.deviceData['xmfl'] = xmflData[i].name
                        //     }
                        // }
                        // 判断将设备状态在转化为名称
                        for (var i = 0; i < deviceStatuData.length; i++) {
                            if (_this.deviceData.sbzt == deviceStatuData[i].id) {
                                _this.deviceData['sbzt'] = deviceStatuData[i].statusName
                            }
                        }
                        for (var i = 0; i < _this.deviceTable.length; i++) {
                            if (_this.deviceTable[i].isOther == 0) {
                                if (_this.deviceTable[i].orders % 2 != 0) {
                                    //将输入框的lable和value存在数组里面，在页面遍历数组显示输入框
                                    if (_this.deviceTable[i].prop == "sydw") {
                                        _this.formRight.push({ key: th_thisis.deviceTable[i].label, value: _this.deviceData['companyname'] })
                                    } else if (_this.deviceTable[i].prop == "jdlx") {
                                        if (_this.deviceData['jdlx'] == 0) {
                                            _this.formRight.push({ key: _this.deviceTable[i].label, value: "检定" })
                                        } else if (_this.deviceData['jdlx'] == 1) {
                                            _this.formRight.push({ key: _this.deviceTable[i].label, value: "设备核查" })
                                        } else if (_this.deviceData['jdlx'] == 2) {
                                            _this.formRight.push({ key: _this.deviceTable[i].label, value: "校准" })
                                        } else if (_this.deviceData['jdlx'] == 3) {
                                            _this.formRight.push({ key: _this.deviceTable[i].label, value: "不检定/校准" })
                                        }
                                    } else {
                                        _this.formRight.push({ key: _this.deviceTable[i].label, value: _this.deviceData[_this.deviceTable[i].prop] })
                                    }

                                } else {
                                    //将输入框的lable和value存在数组里面，在页面遍历数组显示输入框
                                    if (_this.deviceTable[i].prop == "sydw") {
                                        _this.formLeft.push({ key: _this.deviceTable[i].label, value: _this.deviceData['companyname'] })
                                    } else if (_this.deviceTable[i].prop == "jdlx") {
                                        if (_this.deviceData['jdlx'] == 0) {
                                            _this.formRight.push({ key: _this.deviceTable[i].label, value: "检定" })
                                        } else if (_this.deviceData['jdlx'] == 1) {
                                            _this.formRight.push({ key: _this.deviceTable[i].label, value: "校准" })
                                        } else if (_this.deviceData['jdlx'] == 2) {
                                            _this.formRight.push({ key: _this.deviceTable[i].label, value: "设备核查" })
                                        } else if (_this.deviceData['jdlx'] == 3) {
                                            _this.formRight.push({ key: _this.deviceTable[i].label, value: "不检定/校准" })
                                        }
                                    } else {
                                        _this.formLeft.push({ key: _this.deviceTable[i].label, value: _this.deviceData[_this.deviceTable[i].prop] })
                                    }
                                }
                            } else {
                                if (_this.deviceTable[i].orders % 2 != 0) {
                                    //将输入框的lable和value存在数组里面，在页面遍历数组显示输入框
                                    _this.formDetailLeft.push({ key: _this.deviceTable[i].label, value: _this.deviceData[_this.deviceTable[i].prop] })
                                } else {
                                    //将输入框的lable和value存在数组里面，在页面遍历数组显示输入框
                                    _this.formDetailRight.push({ key: _this.deviceTable[i].label, value: _this.deviceData[_this.deviceTable[i].prop] })
                                }
                            }
                        }
                    }
                })

            })
            let userinfo = JSON.parse(localStorage.getItem("user"))
            this.btnRole = userinfo.role.menuId.split(",")
            if ((userinfo.role.menuId).indexOf("187") != -1 || userinfo.userRole == 1) {
                this.activeName = 'other'
                this.isShows = true
            } else {
                this.activeName = 'relevant'
                this.isShows = false
            }
        },
        //返回至设备信息
        returnDeviceinfo() {

            //添加路由跳转至查看设备
            // this.$router.push({
            //     path: "DeviceInfo",
            // });
            this.$router.go(-1)

        },
        // 格式化一级分类列
        formateYjfl() {
            let yjfl = ""
            let deviceTypeData = JSON.parse(sessionStorage.getItem("deviceTypeData"))
            for (var i = 0; i < deviceTypeData.length; i++) {
                if (this.deviceData.yjfl == deviceTypeData[i].id) {
                    this.deviceData[yjfl] = deviceTypeData[i].deviceTypeName
                    debugger;
                    yjfl = deviceTypeData[i].deviceTypeName
                    return yjfl;
                }
            }

        },
        // 格式化二级分类列
        formateEjfl(row, colum) {
            let ejfl = ""
            for (var i = 0; i < this.deviceTypeData.length; i++) {
                if (row.ejfl == this.deviceTypeData[i].id) {
                    ejfl = this.deviceTypeData[i].deviceTypeName
                    return ejfl;
                }
            }
        },
        // 格式化专业分类列
        formateZyfl(row, colum) {
            let zyfl = ""
            for (var i = 0; i < this.zyflData.length; i++) {
                if (row.zyfl == this.zyflData[i].id) {
                    zyfl = this.zyflData[i].name
                    return zyfl;
                }
            }
        },
        // 格式化项目分类列
        formateXmfl(row, colum) {
            let xmfl = ""
            for (var i = 0; i < this.xmflData.length; i++) {
                if (row.xmfl == this.xmflData[i].id) {
                    if (row.zyfl == this.xmflData[i].mId) {
                        xmfl = this.xmflData[i].name
                        return xmfl;
                    }

                }
            }
        },
        handleClick(tab, event) {

        },
        // 查找设备资料
        getDeviceDoc() {
            let _params = {
                deviceId: JSON.parse(sessionStorage.getItem("deviceinfoDetail")).id,
            }
            let _this = this
            selectDeviceinfoDoc(_params).then(datas => {
                let { status, data, message } = datas
                if (status == 200) {
                    _this.deviceDocData = []
                    for (var i = 0; i < data.length; i++) {
                        _this.deviceDocData.push(data[i])
                    }

                }
            })
        },
        // 下载
        downloading(row) {
            this.downloadUtil.downloadFile(row.path, row.name);
        },
        // 在线预览
        onlineView(row) {
            // this.downloadUtil.preview(row.path)
            // if(row.path.substring(row.path.lastIndexOf(".") + 1)=="docx"||row.path.substring(row.path.lastIndexOf(".") + 1)=="doc"){
            //     let _params={
            //         path:row.path
            //     }
            //     download(_params).then(datas=>{
            //             console.log(datas); // 后端返回的是流文件
            //             this.docxdialog=true
            //             docx.renderAsync(datas, this.$refs.file); // 渲染到页面
            //     })
            // }else{

            // }

            if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
                this.previewTitle = "图片预览"
            } else {
                this.previewTitle = "文件预览"
            }
            this.docxdialog = true
            this.$nextTick(() => {
                this.$refs.filePreview.showView(row.path)
            })

        },
        // 格式化时间显示到日期
        formateTime(row) {
            let nowData = new Date(row.createTime)
            let year = nowData.getFullYear();
            let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
            let date = nowData.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${date}`;
        },
        // 去修改页面
        toUpdate() {
            sessionStorage.setItem("deviceUpdate", JSON.stringify(this.deviceData))
            //添加路由跳转至修改设备
            this.$router.push({
                path: "deviceinfoUpdate",

            });
        },
        // 去设备检定页面
        toWarning() {
            //console.log('jd', JSON.stringify(this.deviceData)); return;
            sessionStorage.setItem("data", JSON.stringify(this.deviceData));
            this.$router.push({
                path: "AddVenfication",

            });
        },
        //去校准录入页面
        toCalibrationWarning() {
            sessionStorage.setItem("addCal", true)
            sessionStorage.setItem("dataCal1", JSON.stringify(this.deviceData)); //添加路由跳转至查看设备
            this.$router.push({
                path: "AddCalibration",

            });
        },
        // 去维保页面
        toWeiBao() {
            this.$router.push({
                path: "maintenance",
            });
        },
        // 去报废页面
        toBaoFei() {
            this.$router.push({
                path: "scrap",
            });
        },
        // 去检定页面
        toCheck() {
            this.$router.push({
                path: "verification",
            });
        },
        // 查询设备附件
        selectDeviceAnnex() {
            let _params = {
                deviceId: JSON.parse(sessionStorage.getItem("deviceinfoDetail")).id
            }
            selectAnnex(_params).then(datas => {
                let { data, status, message } = datas
                if (status == 200) {
                    this.annexData = data
                    this.annexNum = data.length
                }
            })
        },
        // 点击通过
        clickTongg() {
            let _params = {
                id: JSON.parse(sessionStorage.getItem("deviceinfoDetail")).id,
                result: 1,
                shyj: "",
                userId: JSON.parse(localStorage.getItem("user")).userId
            }
            examine(_params).then(datas => {
                let { status, message, data } = datas
                if (status == 200) {
                    this.$message({ message: message, type: 'success' });
                    setTimeout(() => {
                        this.$router.go(-1)
                    }, 1500)
                } else {
                    this.$message({ message: message, type: 'error' });
                }
            })
        },
        // 点击驳回
        clickReject() {
            let _params = {
                id: JSON.parse(sessionStorage.getItem("deviceinfoDetail")).id,
                result: 47,
                shyj: this.deviceExamine.shyj,
                userId: JSON.parse(localStorage.getItem("user")).userId
            }
            examine(_params).then(datas => {
                let { status, message, data } = datas
                if (status == 200) {
                    this.$message({ message: message, type: 'success' });
                    setTimeout(() => {
                        this.$router.go(-1)
                    }, 1500)
                } else {
                    this.$message({ message: message, type: 'error' });
                }
            })
        },
        // 点击取消
        clickExit() {
            this.rejectDialog = false
            this.deviceExamine.shyj = ""
        },
        // 点击附件详情
        clickAnnexDetail(row) {
            this.annexDetailDialog = true;
            this.deviceAnnexId = row.id;
            this.$nextTick(() => {
                this.$refs.annexDetailShow.getAnnexDetail()
            })

        },
    },
    created() {
        this.getFormList();
        this.getDeviceDoc();
        this.selectDeviceAnnex();
    }
}
</script>
<style scoped>
.btn {
    float: left;
}

.input {
    width: 90%;
}

.el-form-item {
    margin-bottom: 5px;
}

/* .el-collapse-item__header{
    margin-left: 10px;
    background-color:#cecece!important;
} */
</style>
<style>
.el-input__inner {
    height: 32px !important;
}

.el-input {
    width: 90%
}

.el-collapse-item__header {
    margin-left: 10px;
    background-color: #cecece !important;
    height: 30px;
    flex: 1 0 auto;
    order: -1;
}

.collapse-title {
    flex: 1 0 90%;
    order: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/device/deviceinfoDetail.vue